import React, { useEffect, useState } from 'react'
import Select from 'react-select'

import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'
import ModalCall from 'pages/admin/posCare/ModalCall'

import { httpOk, GET, DELETE } from 'helpers/api'
import { formatDate, formatMoney, returnSign } from 'helpers/helpers'

// Журнал звонков: кому звонили, кто звонил нам и о чём говорили.
//
// Записи заводятся руками — телефонии у нас нет, и другого источника «когда мы
// последний раз разговаривали с точкой» не существует. Отсюда же берёт данные
// раздел «Забота о клиентах»: там те же звонки, только свёрнутые до одной
// последней записи на точку.
//
// Текст по-русски и без t(): админка не переводится (правило проекта).

const DIRECTIONS = [
	{ id: 'out', name: 'Мы звонили' },
	{ id: 'in', name: 'Нам звонили' },
]

const DIRECTION_TITLES = {
	out: 'Мы звонили',
	in: 'Нам звонили',
}

function getDefaultFilter() {
	const date = new Date()

	return {
		'search': '',
		'direction': null,
		'topic_id': null,
		'outcome_id': null,
		'created_by': null,
		'has_problem': false,
		'not_answered': false,
		'page': 0,
		'start_date': formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 13), 'yyyy-MM-dd'),
		'end_date': formatDate(date, 'yyyy-MM-dd'),
	}
}

function Index() {
	const [filterData, setFilterData] = useState(getDefaultFilter())
	const [data, setData] = useState({ 'data': [], 'total': 0 })
	const [pagination, setPagination] = useState({ 'url': '/admin/pos-calls', 'response': null, 'size': 20 })

	const [topics, setTopics] = useState([])
	const [operators, setOperators] = useState([])
	const [outcomes, setOutcomes] = useState([])

	const [modalCall, setModalCall] = useState(false)
	const [selectedCall, setSelectedCall] = useState(null)
	const [deletingId, setDeletingId] = useState(null)

	function buildUrl(nextFilterData) {
		var urlParams = ''

		if (nextFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + encodeURIComponent(nextFilterData.search)
		if (nextFilterData.direction)
			urlParams += returnSign(urlParams) + 'direction=' + nextFilterData.direction
		if (nextFilterData.topic_id)
			urlParams += returnSign(urlParams) + 'topic_id=' + nextFilterData.topic_id
		if (nextFilterData.outcome_id)
			urlParams += returnSign(urlParams) + 'outcome_id=' + nextFilterData.outcome_id
		if (nextFilterData.created_by)
			urlParams += returnSign(urlParams) + 'created_by=' + encodeURIComponent(nextFilterData.created_by)
		if (nextFilterData.has_problem)
			urlParams += returnSign(urlParams) + 'has_problem=true'
		if (nextFilterData.not_answered)
			urlParams += returnSign(urlParams) + 'not_answered=true'
		if (nextFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + nextFilterData.start_date
		if (nextFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + nextFilterData.end_date
		if (nextFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + nextFilterData.page

		return '/admin/pos-calls' + urlParams
	}

	async function searchWithFilter(nextFilterData = filterData) {
		const url = buildUrl(nextFilterData)

		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': url, 'response': response.data })
		}
	}

	async function getHelpers() {
		const topicsResponse = await GET('/admin/helper/call-topics', {}, { loader: false })
		if (httpOk(topicsResponse)) setTopics(topicsResponse.data || [])

		const operatorsResponse = await GET('/admin/helper/call-operators', {}, { loader: false })
		if (httpOk(operatorsResponse)) setOperators(operatorsResponse.data || [])

		const outcomesResponse = await GET('/admin/helper/call-outcomes', {}, { loader: false })
		if (httpOk(outcomesResponse)) setOutcomes(outcomesResponse.data || [])
	}

	function applyFilter(patch) {
		const nextFilterData = { ...filterData, ...patch, 'page': 0 }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function toggleModalCall(bool = false, call = null) {
		setSelectedCall(call)
		setModalCall(bool)
	}

	async function deleteCall(id) {
		const response = await DELETE(`/admin/pos-calls/${id}`, {}, { loader: true })

		if (httpOk(response)) {
			setDeletingId(null)
			searchWithFilter()
			getHelpers()
		}
	}

	function handleResetFilters() {
		const nextFilterData = getDefaultFilter()
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handleSaved() {
		searchWithFilter()
		getHelpers()
	}

	useEffect(() => {
		getHelpers()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="vertical-center">
					<h4 className="mb-0">Звонки [{data.total}]</h4>
					<div className="text-muted fs-6">Кому звонили, кто звонил нам и о чём говорили</div>
				</div>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModalCall(true)}>
					Записать звонок
				</button>
			</div>

			<div className="card mb-3">
				<div className="card-body py-2 d-flex flex-wrap align-items-center gap-3">
					<div style={{ 'width': '340px' }}>
						<PeriodPicker
							startDate={filterData.start_date}
							endDate={filterData.end_date}
							onChange={(period) => applyFilter(period)}
							withTime={false}
						/>
					</div>

					<div style={{ 'width': '240px' }}>
						<input type="text" className="form-control"
							placeholder="Точка, логин, контакт или номер"
							value={filterData.search}
							onChange={(e) => setFilterData({ ...filterData, 'search': e.target.value })}
							onKeyUp={(e) => {
								if (e.key === 'Enter') applyFilter({ 'search': filterData.search })
							}} />
					</div>

					<div style={{ 'width': '170px' }}>
						<Select
							isClearable
							options={DIRECTIONS}
							value={DIRECTIONS.find((item) => item.id === filterData.direction) || ''}
							onChange={(option) => applyFilter({ 'direction': option ? option.id : null })}
							placeholder="Кто звонил"
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>

					<div style={{ 'width': '200px' }}>
						<Select
							isClearable
							options={topics}
							value={topics.find((item) => item.id === filterData.topic_id) || ''}
							onChange={(option) => applyFilter({ 'topic_id': option ? option.id : null })}
							placeholder="Тема"
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>

					<div style={{ 'width': '200px' }}>
						<Select
							isClearable
							options={outcomes}
							value={outcomes.find((item) => item.id === filterData.outcome_id) || ''}
							onChange={(option) => applyFilter({ 'outcome_id': option ? option.id : null })}
							placeholder="Итог"
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>

					<div style={{ 'width': '190px' }}>
						<Select
							isClearable
							options={operators}
							value={operators.find((item) => item.id === filterData.created_by) || ''}
							onChange={(option) => applyFilter({ 'created_by': option ? option.id : null })}
							placeholder="Наш сотрудник"
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>

					<div className="form-check form-switch mb-0">
						<input type="checkbox" className="form-check-input" id="callsProblem"
							checked={filterData.has_problem}
							onChange={(e) => applyFilter({ 'has_problem': e.target.checked })} />
						<label className="form-check-label" htmlFor="callsProblem">С проблемой</label>
					</div>

					<div className="form-check form-switch mb-0">
						<input type="checkbox" className="form-check-input" id="callsNotAnswered"
							checked={filterData.not_answered}
							onChange={(e) => applyFilter({ 'not_answered': e.target.checked })} />
						<label className="form-check-label" htmlFor="callsNotAnswered">Не дозвонились</label>
					</div>

					<button className="btn btn-outline-secondary ms-auto" onClick={() => handleResetFilters()}>
						Сбросить
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<table className="table table-bordered table-hover mb-0">
						<thead>
							<tr>
								<th style={{ 'width': '140px' }}>Когда</th>
								<th>Точка</th>
								<th style={{ 'width': '130px' }}>Кто звонил</th>
								<th>С кем говорили</th>
								<th>Тема</th>
								<th>О чём</th>
								<th style={{ 'width': '140px' }}>Наш сотрудник</th>
								<th style={{ 'width': '150px' }}></th>
							</tr>
						</thead>
						<tbody>
							{data.data.map((row) => (
								<tr key={row.id}>
									<td>{formatDate(row.called_at, 'dd.MM.yyyy HH:mm')}</td>
									<td>
										<div>{row.pos_name}</div>
										<div className="text-muted fs-6">{row.login}</div>
									</td>
									<td>
										<span className={`badge ${row.direction === 'in' ? 'bg-info' : 'bg-secondary'}`}>
											{DIRECTION_TITLES[row.direction]}
										</span>
										{!row.is_answered &&
											<div className="text-danger fs-6">не дозвонились</div>
										}
									</td>
									<td>
										<div>{row.contact_name || '—'}</div>
										<div className="text-muted fs-6">{row.phone || ''}</div>
									</td>
									<td>
										{row.topic_name || '—'}
										{row.has_problem &&
											<div className="text-danger fs-6">проблема</div>
										}
										{/* Итог и договорённости — то, по чему оператор вернётся к точке */}
										{row.outcome_name && <div><span className="badge bg-primary">{row.outcome_name}</span></div>}
										{row.promised_pay_at &&
											<div className="fs-6">
												обещали оплатить до {formatDate(row.promised_pay_at, 'dd.MM.yyyy')}
												{row.promised_amount ? ' · ' + formatMoney(row.promised_amount) : ''}
											</div>
										}
										{row.churn_reason_name && <div className="fs-6 text-danger">причина: {row.churn_reason_name}</div>}
										{row.next_call_at && <div className="fs-6 text-muted">перезвон {formatDate(row.next_call_at, 'dd.MM.yyyy')}</div>}
										{row.task_id && <div className="fs-6 text-muted">задача №{row.task_id}</div>}
									</td>
									<td>
										{row.comment || '—'}
										{/* Отчёт ушёл в телеграм-группу клиента — директор в курсе разговора */}
										{row.report_sent_at &&
											<div className="fs-6 text-muted" title={'Отправлен ' + formatDate(row.report_sent_at, 'dd.MM.yyyy HH:mm')}>
												<i className="uil uil-telegram-alt text-primary"></i> отчёт в группе клиента
											</div>
										}
									</td>
									<td>{row.created_by_name || row.created_by || '—'}</td>
									<td className="text-end">
										{deletingId === row.id
											? <>
												<span className="me-2">Удалить?</span>
												<button className="btn btn-sm btn-danger me-1"
													onClick={() => deleteCall(row.id)}>Да</button>
												<button className="btn btn-sm btn-outline-secondary"
													onClick={() => setDeletingId(null)}>Нет</button>
											</>
											: <>
												<button className="btn btn-sm btn-outline-primary me-1"
													onClick={() => toggleModalCall(true, row)}>
													<i className="uil uil-edit-alt"></i>
												</button>
												<button className="btn btn-sm btn-outline-danger"
													onClick={() => setDeletingId(row.id)}>
													<i className="uil uil-trash-alt"></i>
												</button>
											</>
										}
									</td>
								</tr>
							))}

							{data.data.length === 0 &&
								<tr>
									<td colSpan="8" className="text-center text-muted">Звонков по фильтру нет</td>
								</tr>
							}
						</tbody>
					</table>

					<FilterPagination
						pagination={pagination}
						paginate={handlePaginate} />
				</div>
			</div>

			{/* MODAL — форма звонка. Точку здесь выбирают поиском: журнал открыт
				не по конкретному заведению */}
			<ModalCall
				show={modalCall}
				onHide={() => toggleModalCall()}
				call={selectedCall}
				topics={topics}
				onSaved={handleSaved}
			/>
		</>
	)
}

export default Index
